"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorExportHtml = createErrorExportHtml;
var _server = require("react-dom/server");
var _ExportErrorHtml = require("../components/ExportErrorHtml");
var _jsxRuntime = require("react/jsx-runtime");
function createErrorExportHtml(data) {
  return (0, _server.renderToStaticMarkup)(/*#__PURE__*/(0, _jsxRuntime.jsx)(_ExportErrorHtml.ExportErrorHtml, {
    ...data
  }));
}
